import styles from './search-modal.module.scss';
import { useState } from 'react';
import { WModal } from '../../wrappers/wrapper';
import SearchIcon from '@mui/icons-material/Search';
import dbService from '../../../services/database.service';
import SearchAllModal from '../search-all-modal/search-all-modal';
import SearchHeader from 'components/organisms/search-header/search-header';
import SearchItem from 'components/molecules/search-item/search-item';
import { TUser } from 'models/common';
import { useNavigate } from 'react-router-dom';
import helperService from 'services/helper.service';

const LIMIT = 20;

export default function SearchModal({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const navigate = useNavigate();

  const [searchText, setSearchText] = useState<string>();
  const [userArray, setUserArray] = useState<TUser[]>([]);
  const [openSearchAllModal, setOpenSearchAllModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setSearchText(undefined);
    setOpenSearchAllModal(false);
  };

  const onChange = (char: string) => {
    setSearchText(char);
    if (!char) {
      setUserArray([]);
      return;
    }

    setLoading(true);
    fetchUsers(char);
  };

  const fetchUsers = async (char: string) => {
    try {
      let startingResults = await dbService.getUsers({
        limit: LIMIT,
        relation: true,
        filter: {
          username: { $regex: `^${char}`, $options: 'i' },
        },
      });

      if (startingResults.length < LIMIT) {
        const remainingLimit = LIMIT - startingResults.length;
        const containingResults = await dbService.getUsers({
          limit: remainingLimit,
          relation: true,
          filter: {
            username: { $regex: char, $not: { $regex: `^${char}`, $options: 'i' }, $options: 'i' },
          },
        });

        startingResults = startingResults.concat(containingResults);
      }

      setUserArray(startingResults);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleOpenSearchAllModal = () => {
    setOpenSearchAllModal(true);
  };

  const handleClickUser = (user: TUser) => {
    handleClose();
    navigate(helperService.getNavigateLink(user));
  };

  return (
    <WModal open={open} onClose={handleClose}>
      {openSearchAllModal ? (
        <SearchAllModal
          open={openSearchAllModal}
          searchText={searchText!}
          handleCloseForSearchModal={handleClose}
        />
      ) : (
        <div className={styles.modalContainer}>
          <SearchHeader
            value={searchText || ''}
            loading={loading}
            onChange={onChange}
            debounce={500}
            onClose={handleClose}
          />

          {!searchText ? (
            <div className={styles['empty-search']}>
              <SearchIcon />
              <div className={styles['title']}>Search the Community</div>
              <div className={styles['description']}>
                Try searching for keywords in posts, comments, events, lessons, spaces and more...
              </div>
            </div>
          ) : (
            <div className={styles.searchListWrapper}>
              <div onClick={handleOpenSearchAllModal} className={styles.searchMore}>
                <SearchIcon />
                {searchText} - Search for posts, comments, and more
              </div>
              <div className={styles.users}>
                {userArray.map((user) => (
                  <SearchItem user={user} key={user._id} onClick={handleClickUser} />
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </WModal>
  );
}
